import { type ComponentProps, type FC } from 'react';

import Checkbox from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface CheckboxWithTextProps extends ComponentProps<typeof Checkbox> {
  text: string;
}

const CheckboxWithLabel: FC<CheckboxWithTextProps> = ({ text, className, ...props }) => {
  return (
    <Label className="flex w-full cursor-pointer items-center gap-3 text-sm font-medium leading-none">
      <Checkbox className={cn('cursor-pointer', className)} {...props} />
      {text}
    </Label>
  );
};

export default CheckboxWithLabel;
